<div class="space-x-2">
  @if (showInfoButton()) {
    <i
      class="text-blue-600 hover:text-blue-800 cursor-pointer pi pi-info-circle text-sm"
      (click)="onEditClick($event)"
    ></i>
  }

  @if (hasPermissionDelete()) {
    <i
      class="pi pi-times text-sm cursor-pointer text-gray-400 hover:text-gray-600"
      (click)="onDeleteClick($event)"
    ></i>
  }
</div>
